import Cookie from 'js-cookie'

// Detects whether the Segment analytics client is blocked in this browser (ad-blocker,
// tracking protection, network failure) and persists the verdict to a cookie, so the rest of
// the app — and the server — can know our client-side events may not be reaching Segment.

export const ANALYTICS_BLOCKED_COOKIE = 'analytics_blocked'
export const ANALYTICS_BLOCKED_COOKIE_EXPIRY_DAYS = 30
const DEFAULT_DETECT_TIMEOUT_MS = 4000

// window.analytics starts as the snippet's stub array and is replaced by the real library once
// cdn.segment.com/analytics.min.js loads. analytics.ready() only fires after that swap, so a
// ready() callback that never runs within the timeout means the script was blocked and never
// upgraded the stub.
export const detectAnalyticsBlocked = ({ timeout = DEFAULT_DETECT_TIMEOUT_MS } = {}) =>
  new Promise(resolve => {
    if (typeof window === 'undefined' || !window.analytics || typeof window.analytics.ready !== 'function') {
      resolve(true)
      return
    }

    let settled = false
    const settle = blocked => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      resolve(blocked)
    }

    const timer = setTimeout(() => settle(true), timeout)

    try {
      window.analytics.ready(() => settle(false))
    } catch (error) {
      settle(true)
    }
  })

export const persistAnalyticsBlocked = blocked => {
  try {
    Cookie.set(ANALYTICS_BLOCKED_COOKIE, blocked ? 'true' : 'false', { expires: ANALYTICS_BLOCKED_COOKIE_EXPIRY_DAYS })
  } catch (error) {
    // ignore — cookies may be unavailable
  }
  return blocked
}

export const isAnalyticsBlocked = () => Cookie.get(ANALYTICS_BLOCKED_COOKIE) === 'true'

// Run once at startup: detect, then persist the result. Resolves to the boolean verdict.
export const initAnalyticsStatus = (options = {}) =>
  detectAnalyticsBlocked(options)
    .then(persistAnalyticsBlocked)
    .catch(() => persistAnalyticsBlocked(true))
